import React from 'react';
import '@assets/sass/components/rating.scss';

export default ({fillLevel, colorVersion = 1}) => {
    return (
        <div className={"rating__item fill-" + fillLevel + ' ' + 'color--' + colorVersion}>
            <span className="rating__label">&#9733;</span>
        </div>
    )
};

